import { render, staticRenderFns } from "./ServiceProject.vue?vue&type=template&id=327a13b0&scoped=true&"
import script from "./ServiceProject.vue?vue&type=script&lang=js&"
export * from "./ServiceProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a13b0",
  null
  
)

export default component.exports